export const getOperators = (state) => {
  return state.operators?.data || [];
};

export const getOperatorsLoading = (state) => {
  return state.operators?.loading || false;
};
